import { useAccount } from "../hooks";
import { OptionButton } from "@/react/components/OptionButton";
import { routes, useSimpleKitContext } from "@/react/context/SimpleKitContext";

export function SwitchChain() {
  const { chainId, network, social } = useAccount();
  const { chains, setPendingItem, setRouter } = useSimpleKitContext();

  return (
    <div className="web3kit-space-y-2">
      {chains
        .filter((item: any) => item.id !== chainId)
        .filter((item: any) => social || item.network.symbol === network)
        .map((item: any, index: number) => (
          <OptionButton
            key={index}
            index={index}
            logo={item.logo}
            onClick={() => {
              setPendingItem(() => {
                setRouter(routes.switchingChain);
                return {
                  name: item.name,
                  logo: item.logo,
                  args: [item.id],
                };
              });
            }}
            className="web3kit-w-full"
          >
            {item.name}
          </OptionButton>
        ))}
    </div>
  );
}
